import useSWR from 'swr'
import AccountNav from './AccountNav'
import { Container } from './Container'
import Header from './Header'
import LogoutExpiredUser from './LogoutExpiredUser'
import { useEffect, useState } from 'react'
import { UserAPI } from '../apis/UserAPI'
import {
    formatCurrency,
    getErrorMessage,
    getTotalStoreCredits,
    log,
} from '../helpers/utils'
import { CustomerAPI, CustomerFetcher } from '../apis/CustomerAPI'
import PurchaseStoreCredit from './PurchaseStoreCredit'
import { isNull } from 'lodash'

const Title = ({ customer, totalStoreCredits }) => {
    return (
        <div className="space-y-3 mb-4 items-center">
            <h3 className="text-xl font-bold space-y-1">
                <div className="flex space-x-1">
                    <div>
                        Hello, {customer?.first_name}{' '}
                        <span className="text-olm-gray text-base">
                            #{customer?.id}
                        </span>
                    </div>
                </div>
                <div className="items-center flex space-x-1">
                    {!isNull(totalStoreCredits) && (
                        <p className="text-base font-normal text-olm-green">
                            <b>Available Store Credit:</b>{' '}
                            {formatCurrency(totalStoreCredits, 2)}
                        </p>
                    )}
                </div>
                <PurchaseStoreCredit totalStoreCredits={totalStoreCredits} />
            </h3>
        </div>
    )
}

function MyAccountWrapper({ title, description, children }) {
    const { data: customer, error } = useSWR(
        CustomerAPI.getCustomer,
        CustomerFetcher,
    )

    const [totalStoreCredits, setTotalStoreCredits] = useState(null)

    const handleUserCoupons = async () => {
        try {
            const coupons = await UserAPI.getStoreCredits()
            setTotalStoreCredits(getTotalStoreCredits(coupons))
        } catch (e) {
            log(getErrorMessage(e))
        }
    }

    useEffect(() => {
        handleUserCoupons()
    }, [customer])

    return (
        <div>
            <LogoutExpiredUser customer={customer} error={error} />
            <Header metaTitle={title} />
            <Container>
                <div className="space-y-6">
                    <div>
                        <div className="mx-auto">
                            <Title
                                customer={customer}
                                totalStoreCredits={totalStoreCredits}
                            />
                            <h1 className="text-2xl font-extrabold tracking-tight text-olm-black sm:text2xl">
                                {title}
                            </h1>
                            <p className="mt-2 text-sm text-gray-500">
                                {description}
                            </p>
                        </div>
                    </div>
                    <AccountNav />
                    <div className="md:flex space-y-10 md:space-y-0">
                        {/* <div className="md:w-3/12">
                        <AccountNav />
                    </div> */}
                        <div className="w-full">
                            <div className="mx-auto pb-4">
                                <div className="">{children}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default MyAccountWrapper
